import { render } from "./MakePredictionsRugby.vue?vue&type=template&id=f091d1d6&scoped=true"
import script from "./MakePredictionsRugby.vue?vue&type=script&lang=js"
export * from "./MakePredictionsRugby.vue?vue&type=script&lang=js"

import "./MakePredictionsRugby.vue?vue&type=style&index=0&id=f091d1d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f091d1d6"]])

export default __exports__